const delay = (callback, delay = 200) => {
  setTimeout(() => {
    callback && callback();
  }, delay);
};

export { delay };
